export const getBkkDestinationFilterValue = (
  currentUser,
  { isDistrict, isProvince } = {},
) => {
  if (isDistrict) return currentUser?.district_id || "";
  if (isProvince) return currentUser?.province_id || "";
  return `${currentUser?.username || ""}|${currentUser?.first_name || ""}`;
};
